// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1474":"0ae0b866","3047":"0ae0b866","4598":"0ae0b866","7968":"0ae0b866"}[chunkId] + ".chunk.css";
};